import { render } from "./PopupTuChoiLenh.vue?vue&type=template&id=39d0eac7"
import script from "./PopupTuChoiLenh.vue?vue&type=script&lang=js"
export * from "./PopupTuChoiLenh.vue?vue&type=script&lang=js"

import exportComponent from "E:\\SonPhat\\Project\\fe_smartphone-doi-soat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__